const cmsKey = 'WEBSITE_CMS_SEARCH_HISTORY_KEY';
const splitSymbol = '_&&_';
const maxHistoryKeyLength = 10;

/**
 * 搜索记录暂时维护在localStorage中
 */

export function getSearchHistory() {
  if (!process.browser) return [];
  let keys = localStorage.getItem(cmsKey);
  return keys ? keys?.split(splitSymbol) : [];
}

export function clearSearchHistory() {
  if (!process.browser) return;
  localStorage.setItem(cmsKey, '');
  return getSearchHistory();
}

export function setSearchHistory(key) {
  if (!process.browser) return;
  let historyKeys = getSearchHistory();
  // 将新的记录放在第一位,已经存在的移动到第一位
  let keyTrim = key?.trim();
  if (keyTrim) {
    if (historyKeys.includes(keyTrim)) {
      historyKeys.splice(historyKeys.indexOf(keyTrim), 1);
    }
    historyKeys.unshift(keyTrim);
  }

  // 超出最大数值，删除之前的记录
  if (historyKeys.length > maxHistoryKeyLength) {
    historyKeys = historyKeys.slice(0, maxHistoryKeyLength);
  }
  localStorage.setItem(cmsKey, historyKeys.join(splitSymbol));
}
